
import LayoutMixin from '@/mixins/layout'
import SupportTop from '@/components/page/support-top.vue'
import SupportNav from '@/components/page/support-nav.vue'
import { isHiddenHeaderFn } from '@/utils/utils'
export default {
  components: {
    SupportNav,
    SupportTop,
  },
  mixins: [LayoutMixin],
  async asyncData({ app }) {
    try {
      const res = await app.$API.support.getQuote({ current: 1, size: 10 })
      return {
        downInfo: res.records || [],
      }
    } catch (error) {
      return {
        downInfo: [],
      }
    }
  },
  data() {
    return {
      view: 'button.view',
      lang: this.$route.params.lang,
      pagination: { current: 1, size: 10 },
      downInfo: [
        // {
        //   name: this.$t('serviceSupport.querySupport.fee_rates.exportTitle'),
        //   subTitle: this.$t(
        //     'serviceSupport.querySupport.fee_rates.exportContent'
        //   ),
        //   downUrlZH:
        //     'https://intl-img.sf-express.com/zh/query/priceRateQuery/priceRateContent.pdf',
        //   downUrlEN:
        //     'https://intl-img.sf-express.com/en/query/priceRateQuery/priceRateContent.pdf',
        // },
        // {
        //   name: this.$t('serviceSupport.querySupport.fee_rates.importTitle'),
        //   subTitle: this.$t(
        //     'serviceSupport.querySupport.fee_rates.importContent'
        //   ),
        //   downUrlZH:
        //     'https://intl-img.sf-express.com/zh/query/priceRateQuery/priceRateContent1.pdf',
        //   downUrlEN:
        //     'https://intl-img.sf-express.com/en/query/priceRateQuery/priceRateContent1.pdf',
        // },
      ],
    }
  },
  head() {
    return {
      title:
        this.$t(`serviceSupport.querySupport.fee_rate`) +
        this.$t('navs.suffixName'),
    }
  },
  computed: {
    // 判断是否需要隐藏公共部分
    isHiddenHeader() {
      console.log(this.$route,'--------------');
      return isHiddenHeaderFn(this.$route)
    },
  },
}
